import { createContext, useContext, ReactNode } from 'react'
import { useGetLessonOverviewQuery } from 'util/rtk-api'
import type { LessonOverview } from '@all-for-one/shared-types'

interface QuestionResultsContextType {
    classId: string
    lessonId: string
    questionId: string
    overview?: LessonOverview
    isOverviewLoading: boolean
    overviewError?: unknown
}

const QuestionResultsContext = createContext<QuestionResultsContextType | null>(null)

export const useQuestionResultsContext = () => {
    const ctx = useContext(QuestionResultsContext)
    if (!ctx) throw new Error('useQuestionResultsContext must be used within QuestionResultsContextProvider')
    return ctx
}

export const QuestionResultsContextProvider = ({ children, classId, lessonId, questionId }: { children: ReactNode, classId: string, lessonId: string, questionId: string }) => {
    const { data: overview, isLoading: isOverviewLoading, error: overviewError } = useGetLessonOverviewQuery({ classId, lessonId })
    return (
        <QuestionResultsContext.Provider value={{ classId, lessonId, questionId, overview, isOverviewLoading, overviewError }}>
            {children}
        </QuestionResultsContext.Provider>
    )
}


